var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { Text } from '@oneaudi/unified-web-components';
import { DangerousElement } from '../../../../components';
import { DisclaimerContainer } from './styles/FinanceRethink.styles';
import { readFinance, getValueFromPath } from '../../../utils';
import { useServicesContext } from '../../../../context';
export const Disclaimer = ({ vehicleBasic, isPlp, dynamicFinancingValues, }) => {
    var _a, _b, _c, _d;
    const { getConfiguration, getAdditionalService } = useServicesContext();
    const logger = getAdditionalService('s2:logger');
    const { disclaimerTypePathInPDP, disclaimerType: configuredDisclaimer } = getConfiguration() || {};
    const storeName = ((_a = vehicleBasic.type) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'N' ? 'VTP_FINANCING_NC' : 'VTP_FINANCING_UC';
    const [selectedDisclaimer, setSelectedDisclaimer] = useState(null);
    const disclaimerMapFromSCS = {
        global: (_b = vehicleBasic === null || vehicleBasic === void 0 ? void 0 : vehicleBasic.financing) === null || _b === void 0 ? void 0 : _b.globalDisclaimer,
        product: (_c = vehicleBasic === null || vehicleBasic === void 0 ? void 0 : vehicleBasic.financing) === null || _c === void 0 ? void 0 : _c.productDisclaimer,
        calculation: (_d = vehicleBasic === null || vehicleBasic === void 0 ? void 0 : vehicleBasic.financing) === null || _d === void 0 ? void 0 : _d.calculationDisclaimer,
    };
    useEffect(() => {
        if (isPlp) {
            setSelectedDisclaimer(disclaimerMapFromSCS[configuredDisclaimer === null || configuredDisclaimer === void 0 ? void 0 : configuredDisclaimer.toLowerCase()]);
        }
    }, []);
    const fetchDisclaimer = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            return yield readFinance(storeName);
        }
        catch (err) {
            logger === null || logger === void 0 ? void 0 : logger.error(err);
        }
        return undefined;
    });
    useEffect(() => {
        if (!isPlp) {
            fetchDisclaimer().then((result) => {
                var _a;
                if (result) {
                    const disclaimersFromStorage = (_a = result === null || result === void 0 ? void 0 : result.financing[vehicleBasic.id]) === null || _a === void 0 ? void 0 : _a.financeResponseData;
                    const disclaimerInPDP = disclaimersFromStorage && disclaimerTypePathInPDP
                        ? getValueFromPath(disclaimersFromStorage, disclaimerTypePathInPDP)
                        : '';
                    setSelectedDisclaimer(disclaimerInPDP);
                }
                else {
                    setSelectedDisclaimer(disclaimerMapFromSCS[configuredDisclaimer === null || configuredDisclaimer === void 0 ? void 0 : configuredDisclaimer.toLowerCase()]);
                }
            });
        }
    }, [dynamicFinancingValues, disclaimerTypePathInPDP]);
    if (!selectedDisclaimer) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(DisclaimerContainer, null,
            React.createElement(Text, { tag: "span", variant: { type: 'copy', order: '2', style: 'normal' } },
                React.createElement(DangerousElement, { as: "span", html: selectedDisclaimer })))));
};
